/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_Table_LabelInputs */

const en_gc_resources_compare_table_label = /** @type {(inputs: Gc_Resources_Compare_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft and Microsoft Excel comparison`)
};

const zh_gc_resources_compare_table_label = /** @type {(inputs: Gc_Resources_Compare_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 与 Microsoft Excel 对比`)
};

/**
* | output |
* | --- |
* | "GridCraft and Microsoft Excel comparison" |
*
* @param {Gc_Resources_Compare_Table_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_table_label = /** @type {((inputs?: Gc_Resources_Compare_Table_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_Table_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_table_label(inputs)
	return zh_gc_resources_compare_table_label(inputs)
});
export { gc_resources_compare_table_label as "gc.resources.compare.table_label" }